module.exports = __webpack_public_path__ + "static/media/compreblindados.3ca678a0.png";